import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import {
  Label,
  Input,
} from 'reactstrap';
import Flatpickr from 'react-flatpickr';
import { useIntl } from 'react-intl';

import 'flatpickr/dist/themes/airbnb.css';

import HelpIcon from '../HelpIcon';

const UploadFileDate = ({
  isEdit,
  selectedFile,
  selectedFiles,
  handleFormChange,
}) => {
  const intl = useIntl();

  const getDateValue = () => {
    if (isEdit && selectedFiles.length === 1) {
      return selectedFiles[0].original_datetime;
    }

    if (selectedFiles.length > 1) {
      return null;
    }

    if (selectedFile) {
      return selectedFile.original_datetime;
    }

    return null;
  };

  return (
    <>
      <Label for="selectFileDate">
        {intl.formatMessage({ defaultMessage: 'Created date' })}
        <HelpIcon id="created-date-help-icon" permanent autohide={false}>
          Optionally override your original creation date.{' '}
          <Link
            to="/admin/workspace?tab=advanced"
            onClick={() => {
              window.open(`${window.location.origin}/admin/workspace?tab=advanced`, '_blank').focus();
            }}
          >
            Disable here
          </Link>
        </HelpIcon>
      </Label>
      <Flatpickr
        render={
          ({ defaultValue, value, ...props }, ref) => (
            <Input {...props} defaultValue={defaultValue} innerRef={ref} />
          )
        }
        data-enable-time
        value={getDateValue()}
        onChange={(dates, date) => {
          handleFormChange({ target: { name: 'fileDate', value: `${date}:00` } });
        }}
      />
    </>
  );
};

UploadFileDate.propTypes = {
  isEdit: PropTypes.bool.isRequired,
  selectedFile: PropTypes.object,
  selectedFiles: PropTypes.array.isRequired,
  handleFormChange: PropTypes.func.isRequired,
};

UploadFileDate.defaultProps = {
  selectedFile: null,
};

export default UploadFileDate;
